import { useAuth } from '@host/auth';

/**
 * Hook kiểm tra quyền người dùng
 * 
 * Usage:
 *   const { can } = usePermission();
 *   if (can('domains', 'create')) { ... }
 *   {can('domains', 'delete') && <DeleteButton />}
 */
export function usePermission() {
  const { user } = useAuth();
  const permissions = user?.permissions || [];
  const roles = user?.roles || [];

  const can = (module, action) => {
    // System admin có wildcard (từ RBAC, không dựa vào cột role cũ)
    if (permissions.includes('*')) return true;
    return permissions.includes(`${module}:${action}`);
  };

  const hasRole = (roleName) => {
    return roles.includes(roleName);
  };

  return { can, hasRole, permissions, roles };
}
